export const generateThumbnails = async ({
  videoSrc,
  containerRef,
  aspectRatio,
  quantity,
  onItemSuccess,
  onSuccess,
  thumbnailCount = 10,
  scaleRatio = 1,
}: {
  videoSrc: string;
  containerRef: React.RefObject<HTMLDivElement | null>;
  aspectRatio: number;
  quantity: number;
  onItemSuccess?: (index: number, image: string) => void;
  onSuccess?: (images: string[]) => void;
  thumbnailCount?: number;
  /** 缩放比例 */
  scaleRatio?: number;
}) => {
  try {
    const tempVideo = document.createElement('video');
    tempVideo.src = videoSrc;
    tempVideo.crossOrigin = 'anonymous';
    await new Promise<void>((resolve) => {
      // 等待视频加载元据
      tempVideo.addEventListener('loadedmetadata', () => resolve(), { once: true });
      tempVideo.load();
    });
    const tempCanvas = document.createElement('canvas');
    const ctx = tempCanvas.getContext('2d');
    if (!ctx) return;
    const containerWidth = containerRef.current?.clientWidth || 800;
    tempCanvas.width = scaleRatio * (containerWidth / thumbnailCount);
    tempCanvas.height = tempCanvas.width / aspectRatio;
    const duration = tempVideo.duration;
    if (!duration || Number.isNaN(duration)) return;
    const interval = duration / thumbnailCount;
    const newThumbnails: string[] = [];
    for (let i = 0; i < thumbnailCount; i++) {
      const timePoint = i === 0 ? 0.01 : i * interval; // 避免第一帧从 0 开始，Safari 可能不触发 seeked 事件
      tempVideo.currentTime = timePoint;
      await new Promise<void>((resolve) => {
        const seekHandler = () => {
          ctx.drawImage(tempVideo, 0, 0, tempCanvas.width, tempCanvas.height);
          const imageUrl = tempCanvas.toDataURL('image/webp', quantity);
          newThumbnails.push(imageUrl);
          onItemSuccess?.(i, imageUrl);
          tempVideo.removeEventListener('seeked', seekHandler);
          resolve();
        };
        tempVideo.addEventListener('seeked', seekHandler, { once: true });
      });
    }
    // setVideoImages(newThumbnails);
    onSuccess?.(newThumbnails);
    // onSuccess;
  } catch (error) {
    console.error('生成视频缩略图失败:', error);
  }
};
